// ***********************************************//
import { useNavigate } from "react-router-dom";
import { A11y, Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import { extractHourFromDate } from "../bigNumberDateAgenda";
import { ConvertDate } from "../ConvertDate";
import "./agendaSlider.css";

const AgendaSlider = ({ data, spectacles }) => {
	const history = useNavigate();
	

	const linkToAgenda = (id) => {
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
		history(`/spectacles/detail/${id}`);
	};
	// Fonction pour trouver le spectacle complet à partir de l'ID
	const getSpectacleData = (spectacleId) => {
		// if (!spectacles) return null;
		return spectacles.find(s => s.id === spectacleId);
	};

	return (
		<Swiper
			className="containerAgendaSliderHome"
			// install Swiper modules
			modules={[Navigation, A11y, Autoplay]}
			spaceBetween={20}
			slidesPerView={data.length >= 1 ? 3 : 1}
			navigation
			breakpoints={{
				0: {
					slidesPerView: 1,
				},
				800: {
					slidesPerView: 2,
				},
				1400: {
					slidesPerView: 2,
				},
			}}
			loop={false}
		>
			{data.map((event, index) => {
				const spectacleData = getSpectacleData(event.spectacle.id);
				const affiche = spectacleData?.affiche;
				const spectacleName = event.titre || spectacleData?.titre || event.spectacle.id;

				return (
					<SwiperSlide key={index}>
						<div
							onClick={() => linkToAgenda(event.spectacle.id)}
							key={index}
							className="cardAgenda"
						>
							<div className="cardAgendaLeft">
								{/* Image de l'affiche dans un cercle */}
								<div className="cardAgendaImageCircle">
									{affiche && (
										<img src={affiche} alt={spectacleName} className="cardAgendaImage" />
									)}
								</div>
							</div>

							<div className="cardAgendaRight">
								<div className="cardAgendaHeader">
									<div className="cardAgendaTitleSection">
										<h3 className="titleEvent">{spectacleName.toUpperCase()}</h3>
										{event.mini_description && (
											<p className="descriptionEvent">
												{event.mini_description}
											</p>
										)}
									</div>
								</div>

								<div className="cardAgendaInfo">
									<div className="cardAgendaInfoItem">
										<div className="dateEventBadge">
											<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
												<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
											</svg>
											<span>{ConvertDate(event.date, "sansJour")}</span>
										</div>

										<div className="heureEventBadge">
											<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
												<path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
												<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
											</svg>
											<span>{event.heure}</span>
										</div>
									</div>

									{event.adresse && (
										<div className="adresseEventItem">
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
												<path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
											</svg>
											<span>{event.adresse}</span>
										</div>
									)}
								</div>
							</div>
						</div>
					</SwiperSlide>
				);
			})}
		</Swiper>
	);
};

export default AgendaSlider;
